import { ThemeColorVariable as u } from "../theme-types.js";
import { ThemeIconSizeToken as n, ThemeBreakPointToken as k, ThemeShadowToken as D, ThemeFontSizeToken as r, ThemeFontToken as m, ThemeRadiusToken as t, ThemeSpaceToken as d, ThemeBorderToken as i, ThemeColorToken as e } from "./theme-tokens.js";
function S(a, f) {
  return {
    colors: {
      [e.Primary]: {
        default: a.primary,
        ...a.primaryDark && { _dark: a.primaryDark }
      },
      [e.PrimaryHover]: {
        default: a.primaryHover,
        ...a.primaryHoverDark && { _dark: a.primaryHoverDark }
      },
      [e.PrimaryActive]: {
        default: a.primaryActive,
        ...a.primaryActiveDark && { _dark: a.primaryActiveDark }
      },
      [e.OnPrimary]: {
        default: a.onPrimary,
        ...a.onPrimaryDark && { _dark: a.onPrimaryDark }
      },
      [e.PrimaryContainer]: {
        default: a.primaryContainer,
        ...a.primaryContainerDark && {
          _dark: a.primaryContainerDark
        }
      },
      [e.OnPrimaryContainer]: {
        default: a.onPrimaryContainer,
        ...a.onPrimaryContainerDark && {
          _dark: a.onPrimaryContainerDark
        }
      },
      [e.Secondary]: {
        default: a.secondary,
        ...a.secondaryDark && { _dark: a.secondaryDark }
      },
      [e.SecondaryHover]: {
        default: a.secondaryHover,
        ...a.secondaryHoverDark && { _dark: a.secondaryHoverDark }
      },
      [e.SecondaryActive]: {
        default: a.secondaryActive,
        ...a.secondaryActiveDark && {
          _dark: a.secondaryActiveDark
        }
      },
      [e.OnSecondary]: {
        default: a.onSecondary,
        ...a.onSecondaryDark && { _dark: a.onSecondaryDark }
      },
      [e.SecondaryContainer]: {
        default: a.secondaryContainer,
        ...a.secondaryContainerDark && {
          _dark: a.secondaryContainerDark
        }
      },
      [e.OnSecondaryContainer]: {
        default: a.onSecondaryContainer,
        ...a.onSecondaryContainerDark && {
          _dark: a.onSecondaryContainerDark
        }
      },
      [e.Accent]: {
        default: a.accent,
        ...a.accentDark && { _dark: a.accentDark }
      },
      [e.AccentHover]: {
        default: a.accentHover,
        ...a.accentHoverDark && { _dark: a.accentHoverDark }
      },
      [e.AccentHoverAlpha]: {
        default: a.accentHoverAlpha,
        ...a.accentHoverAlphaDark && {
          _dark: a.accentHoverAlphaDark
        }
      },
      [e.AccentActive]: {
        default: a.accentActive,
        ...a.accentActiveDark && { _dark: a.accentActiveDark }
      },
      [e.AccentActiveAlpha]: {
        default: a.accentActiveAlpha,
        ...a.accentActiveAlphaDark && {
          _dark: a.accentActiveAlphaDark
        }
      },
      [e.OnAccent]: {
        default: a.onAccent,
        ...a.onAccentDark && { _dark: a.onAccentDark }
      },
      [e.AccentContainer]: {
        default: a.accentContainer,
        ...a.accentContainerDark && {
          _dark: a.accentContainerDark
        }
      },
      [e.OnAccentContainer]: {
        default: a.onAccentContainer,
        ...a.onAccentContainerDark && {
          _dark: a.onAccentContainerDark
        }
      },
      [e.Background]: {
        default: a.background,
        ...a.backgroundDark && { _dark: a.backgroundDark }
      },
      [e.OnBackground]: {
        default: a.onBackground,
        ...a.onBackgroundDark && { _dark: a.onBackgroundDark }
      },
      [e.OnBackgroundBorder]: {
        default: a.onBackgroundBorder,
        ...a.onBackgroundBorderDark && {
          _dark: a.onBackgroundBorderDark
        }
      },
      [e.OnBackgroundSubdued]: {
        default: a.onBackgroundSubdued,
        ...a.onBackgroundSubduedDark && {
          _dark: a.onBackgroundSubduedDark
        }
      },
      [e.BackgroundDisabled]: {
        default: a.backgroundDisabled,
        ...a.backgroundDisabledDark && {
          _dark: a.backgroundDisabledDark
        }
      },
      [e.OnBackgroundHeader]: {
        default: a.onBackgroundHeader,
        ...a.onBackgroundHeaderDark && {
          _dark: a.onBackgroundHeaderDark
        }
      },
      [e.Surface]: {
        default: a.surface,
        ...a.surfaceDark && { _dark: a.surfaceDark }
      },
      [e.OnSurface]: {
        default: a.onSurface,
        ...a.onSurfaceDark && { _dark: a.onSurfaceDark }
      },
      [e.ViewHeaderBackground]: {
        default: a.viewHeaderBackground,
        ...a.viewHeaderBackgroundDark && { _dark: a.viewHeaderBackgroundDark }
      },
      [e.OnSurfaceBorder]: {
        default: a.onSurfaceBorder,
        ...a.onSurfaceBorderDark && {
          _dark: a.onSurfaceBorderDark
        }
      },
      [e.OnSurfaceSubdued]: {
        default: a.onSurfaceSubdued,
        ...a.onSurfaceSubduedDark && {
          _dark: a.onSurfaceSubduedDark
        }
      },
      [e.SurfaceDisabled]: {
        default: a.surfaceDisabled,
        ...a.surfaceDisabledDark && {
          _dark: a.surfaceDisabledDark
        }
      },
      [e.OnSurfaceHeader]: {
        default: a.onSurfaceHeader,
        ...a.onSurfaceHeaderDark && {
          _dark: a.onSurfaceHeaderDark
        }
      },
      [e.Info]: {
        default: a.info,
        ...a.infoDark && { _dark: a.infoDark }
      },
      [e.InfoHover]: {
        default: a.infoHover,
        ...a.infoHoverDark && { _dark: a.infoHoverDark }
      },
      [e.InfoActive]: {
        default: a.infoActive,
        ...a.infoActiveDark && { _dark: a.infoActiveDark }
      },
      [e.OnInfo]: {
        default: a.onInfo,
        ...a.onInfoDark && { _dark: a.onInfoDark }
      },
      [e.InfoContainer]: {
        default: a.infoContainer,
        ...a.infoContainerDark && { _dark: a.infoContainerDark }
      },
      [e.OnInfoContainer]: {
        default: a.onInfoContainer,
        ...a.onInfoContainerDark && {
          _dark: a.onInfoContainerDark
        }
      },
      [e.Success]: {
        default: a.success,
        ...a.successDark && { _dark: a.successDark }
      },
      [e.SuccessHover]: {
        default: a.successHover,
        ...a.successHoverDark && { _dark: a.successHoverDark }
      },
      [e.SuccessActive]: {
        default: a.successActive,
        ...a.successActiveDark && { _dark: a.successActiveDark }
      },
      [e.OnSuccess]: {
        default: a.onSuccess,
        ...a.onSuccessDark && { _dark: a.onSuccessDark }
      },
      [e.SuccessContainer]: {
        default: a.successContainer,
        ...a.successContainerDark && {
          _dark: a.successContainerDark
        }
      },
      [e.OnSuccessContainer]: {
        default: a.onSuccessContainer,
        ...a.onSuccessContainerDark && {
          _dark: a.onSuccessContainerDark
        }
      },
      [e.Warning]: {
        default: a.warning,
        ...a.warningDark && { _dark: a.warningDark }
      },
      [e.WarningHover]: {
        default: a.warningHover,
        ...a.warningHoverDark && { _dark: a.warningHoverDark }
      },
      [e.WarningActive]: {
        default: a.warningActive,
        ...a.warningActiveDark && { _dark: a.warningActiveDark }
      },
      [e.OnWarning]: {
        default: a.onWarning,
        ...a.onWarningDark && { _dark: a.onWarningDark }
      },
      [e.WarningContainer]: {
        default: a.warningContainer,
        ...a.warningContainerDark && {
          _dark: a.warningContainerDark
        }
      },
      [e.OnWarningContainer]: {
        default: a.onWarningContainer,
        ...a.onWarningContainerDark && {
          _dark: a.onWarningContainerDark
        }
      },
      [e.Error]: {
        default: a.error,
        ...a.errorDark && { _dark: a.errorDark }
      },
      [e.ErrorHover]: {
        default: a.errorHover,
        ...a.errorHoverDark && { _dark: a.errorHoverDark }
      },
      [e.ErrorActive]: {
        default: a.errorActive,
        ...a.errorActiveDark && { _dark: a.errorActiveDark }
      },
      [e.OnError]: {
        default: a.onError,
        ...a.onErrorDark && { _dark: a.onErrorDark }
      },
      [e.ErrorContainer]: {
        default: a.errorContainer,
        ...a.errorContainerDark && {
          _dark: a.errorContainerDark
        }
      },
      [e.OnErrorContainer]: {
        default: a.onErrorContainer,
        ...a.onErrorContainerDark && {
          _dark: a.onErrorContainerDark
        }
      },
      [e.Neutral]: {
        default: a.neutral,
        ...a.neutralDark && { _dark: a.neutralDark }
      },
      [e.NeutralHover]: {
        default: a.neutralHover,
        ...a.neutralHoverDark && { _dark: a.neutralHoverDark }
      },
      [e.NeutralActive]: {
        default: a.neutralActive,
        ...a.neutralActiveDark && { _dark: a.neutralActiveDark }
      },
      [e.OnNeutral]: {
        default: a.onNeutral,
        ...a.onNeutralDark && { _dark: a.onNeutralDark }
      },
      [e.NeutralContainer]: {
        default: a.neutralContainer,
        ...a.neutralContainerDark && {
          _dark: a.neutralContainerDark
        }
      },
      [e.OnNeutralContainer]: {
        default: a.onNeutralContainer,
        ...a.onNeutralContainerDark && {
          _dark: a.onNeutralContainerDark
        }
      },
      [e.Shadow]: "#000000",
      [e.ModalOverlay]: "#FAFAFA50",
      // 80% opacity
      [e.ViewFinderOverlay]: "#00000078",
      // 48% opacity
      [e.ShadowHeader]: "#0000003D",
      // 24% opacity
      [e.ShadowFooter]: "#00000029",
      // 16% opacity
      [e.ShadowCard]: "#00000029",
      // 16% opacity
      [e.ShadowScroll]: "#0000001F",
      // 12% opacity
      [e.PickerOnPicker]: "#151411",
      [e.PickerBerry]: "#A9B2CD",
      [e.PickerBerryLight]: "#CAD0E7",
      [e.PickerCoral]: "#F69C9C",
      [e.PickerCoralLight]: "#FFCCCC",
      [e.PickerFlamingo]: "#E39FB6",
      [e.PickerFlamingoLight]: "#F1C6D1",
      [e.PickerFog]: "#C3C3C3",
      [e.PickerFogLight]: "#D9D9D9",
      [e.PickerHoney]: "#F2B961",
      [e.PickerHoneyLight]: "#F8D9A8",
      [e.PickerLemon]: "#F5EE77",
      [e.PickerLemonLight]: "#F4F0AF",
      [e.PickerLime]: "#9BC87E",
      [e.PickerLimeLight]: "#CAE1BA",
      [e.PickerOlive]: "#9BCDB6",
      [e.PickerOliveLight]: "#CBE4D7",
      [e.PickerPlum]: "#D2A5C2",
      [e.PickerPlumLight]: "#E5C3DA",
      [e.PickerSky]: "#84C1E9",
      [e.PickerSkyLight]: "#BFDDF2"
    },
    borders: {
      [i.None]: "none",
      [i.XSmall]: "0.0625rem solid",
      // 1px
      [i.Small]: "0.125rem solid",
      // 2px
      [i.Medium]: "0.25rem solid",
      // 4px
      [i.Large]: "0.5rem solid",
      // 8px
      [i.XLarge]: "0.5rem solid"
      // 8px purposly same as Large for now
    },
    space: {
      [d.None]: "0",
      [d.XSmall]: "0.25rem",
      // 4px
      [d.Small]: "0.5rem",
      // 8px
      [d.Medium]: "1rem",
      // 16px
      [d.Large]: "2rem",
      // 32px
      [d.XLarge]: "3rem",
      // 48px
      [d.X2Large]: "5rem"
      // 80px
    },
    radii: {
      [t.None]: "0",
      [t.XSmall]: "0.125rem",
      // 2px
      [t.Small]: "0.25rem",
      // 4px
      [t.Medium]: "0.5rem",
      // 8px
      [t.Large]: "1rem",
      // 16px
      [t.XLarge]: "31.25rem"
      // 500px
    },
    fonts: {
      [m.Body]: f.body,
      [m.Header]: f.header,
      [m.SubHeader]: f.subheader
    },
    fontSizes: {
      [r.XSmall]: "0.75rem",
      // 12px
      [r.Small]: "0.875rem",
      // 14px
      [r.Medium]: "1rem",
      // 16px
      [r.Large]: "1.125rem",
      // 18px
      [r.XLarge]: "1.5rem",
      // 24px
      [r.X2Large]: "2rem",
      // 32px
      [r.X3Large]: "2.5rem",
      // 40px
      [r.X4Large]: "3.25rem",
      // 52px
      [r.X5Large]: "4rem",
      // 64px
      [r.X6Large]: "5rem"
      // 80px
    },
    shadows: {
      [D.Small]: `0px 4px 12px 0px ${u.ShadowCard}`,
      [D.Medium]: `0px 4px 20px 4px ${u.ShadowCard}`,
      [D.Large]: `0px 8px 40px 8px ${u.ShadowCard}`,
      [D.Header]: `0px 8px 40px 8px ${u.ShadowHeader}`,
      [D.Footer]: `0px 0px 16px 0px ${u.ShadowFooter}`
    },
    breakpoints: {
      [k.Base]: "0em",
      [k.Small]: "30em",
      // 480px
      [k.Medium]: "48em",
      // 768px
      [k.Large]: "62em",
      // 992px
      [k.XLarge]: "80em",
      // 1280px
      [k.X2Large]: "96em"
      // 1536px
    },
    iconSizes: {
      [n.XSmall]: "1rem",
      // 16px
      [n.Small]: "1.25rem",
      // 20px
      [n.Medium]: "1.5rem",
      // 24px
      [n.Large]: "2rem",
      // 32px
      [n.XLarge]: "2.5rem",
      // 40px
      [n.X2Large]: "3rem",
      // 48 px
      [n.X3Large]: "3.5rem"
      // 56px
    }
  };
}
export {
  S as createSemanticTokens
};
